import { DATE, DATE_TIME } from 'customer-data-objects/property/PropertyTypes';
import { H7 } from 'foundations-components/transitional/components/H7';
import { hasNewIlsTimeFiltersEnabled, hasRemoveTimezoneForDates } from '../../permissions/gates';
import FormattedMessage from 'I18n/components/FormattedMessage';
import Small from 'UIComponents/elements/Small';
import UIInlineLabel from 'UIComponents/form/UIInlineLabel';
import UIRadioInput from 'UIComponents/input/UIRadioInput';
import UIToggleGroup from 'UIComponents/input/UIToggleGroup';
import HR from 'UIComponents/elements/HR';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const TimezoneToggle = ({
  conditionId,
  fieldType,
  useUTC,
  onChange,
  getIsUngated,
  timezoneOptions
}) => {
  if (timezoneOptions.length <= 1) {
    return null;
  }
  if (!hasNewIlsTimeFiltersEnabled(getIsUngated)) {
    return null;
  }
  const showWarningBanner = fieldType === DATE && !useUTC && !hasRemoveTimezoneForDates(getIsUngated) || fieldType === DATE_TIME && useUTC;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(HR, {
      distance: "small"
    }), /*#__PURE__*/_jsx(UIInlineLabel, {
      "data-test-id": "fr-timezone-toggle",
      label: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "customerDataFiltersUI.customerDataFilters.TimezoneToggle.label"
      }),
      children: /*#__PURE__*/_jsxs(UIToggleGroup, {
        name: `timezone-toggle-${conditionId}`,
        children: [/*#__PURE__*/_jsx(UIRadioInput, {
          "data-test-id": "fr-portal-radio",
          checked: !useUTC,
          inline: true,
          onChange: () => onChange(false),
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "customerDataFiltersUI.customerDataFilters.TimezoneToggle.portal"
          })
        }), /*#__PURE__*/_jsx(UIRadioInput, {
          "data-test-id": "fr-utc-radio",
          checked: useUTC,
          inline: true,
          onChange: () => onChange(true),
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "customerDataFiltersUI.customerDataFilters.TimezoneToggle.utc"
          })
        })]
      })
    }), showWarningBanner && /*#__PURE__*/_jsxs(Alert, {
      type: "warning",
      children: [/*#__PURE__*/_jsx(H7, {
        marginBlockEnd: "0",
        children: fieldType === DATE ? /*#__PURE__*/_jsx(FormattedMessage, {
          message: "customerDataFiltersUI.customerDataFilters.TimezoneToggle.portalTimezoneUsageWarning.title"
        }) : /*#__PURE__*/_jsx(FormattedMessage, {
          message: "customerDataFiltersUI.customerDataFilters.TimezoneToggle.utcUsageWarning.title"
        })
      }), /*#__PURE__*/_jsx(Small, {
        children: fieldType === DATE ? /*#__PURE__*/_jsx(FormattedMessage, {
          message: "customerDataFiltersUI.customerDataFilters.TimezoneToggle.portalTimezoneUsageWarning.description"
        }) : /*#__PURE__*/_jsx(FormattedMessage, {
          message: "customerDataFiltersUI.customerDataFilters.TimezoneToggle.utcUsageWarning.description"
        })
      })]
    })]
  });
};
export default TimezoneToggle;